import {matchPath} from 'react-router-dom'

/**
 * GA4 콘텐츠 그룹 (content_group).
 * 같은 종류의 페이지(예: 모든 도서관 상세)를 한 줄로 묶어 보기 위한 값.
 * 페이지별 구분은 page_title(도서관명·책 제목)과 page_path로 한다.
 *
 * ⚠️ iOS(booksitout-ios `Common/ScreenTracking.swift`)에도 같은 표가 있다. 바꿀 때 둘 다 바꿀 것.
 * 위에서부터 처음 맞는 패턴을 쓴다 (구체적인 경로를 먼저).
 */
const CONTENT_GROUPS: [pattern: string, group: string][] = [
	['/', '홈'],
	['/book', '전체 서재'],
	['/book/mine', '내 서재'],
	['/book/mine/:bookId/*', '내 책 상세'],
	['/book/author/:urlName', '작가'],
	['/book/publisher/:urlName', '출판사'],
	['/book/statistics/*', '통계'],
	['/book/calendar', '독서 달력'],
	['/book/goal', '목표'],
	['/book/:isbn', '책 상세'],
	['/add/*', '책 추가'],
	['/library', '도서관'],
	['/library/near', '주변 도서관'],
	['/library/ranking', '도서관 순위'],
	['/library/membership/*', '도서관 회원증'],
	['/library/by-region/*', '지역별 도서관'],
	['/library/:libraryId', '도서관 상세'],
	['/login/*', '로그인'],
	['/settings/*', '설정'],
	['/community/*', '커뮤니티'],
	['/users/*', '프로필'],
	['/products/*', '제품 소개'],
	['/faq', '자주 묻는 질문'],
]

export const contentGroupOf = (pathname: string): string =>
	CONTENT_GROUPS.find(([pattern]) => matchPath({path: pattern, end: true}, pathname) != null)?.[1] ?? '기타'
